<template>

    <div>

        <h2 class="section-title">Leistungen</h2>

        <p class="section-intro">
            Massgeschneiderte Lösungen statt Standardware. Ob IT-Infrastruktur,
            Webentwicklung oder Automation: alles wird an die konkreten Gegebenheiten
            des Kunden angepasst.
        </p>

        <div class="row mt-4">

            <!-- IT-Infrastruktur -->
            <div class="col-12 col-md-6 mb-4">

                <div class="service-card h-100">

                    <div class="service-icon">
                        <i class="fa-solid fa-server"></i>
                    </div>

                    <h5>IT-Infrastruktur</h5>

                    <p>
                        Aufbau und Betreuung kompletter IT-Infrastruktur für kleine bis
                        mittlere Betriebe. Firewall, Netzwerk, WLAN, Mailserver,
                        Ticketsysteme und Benutzerverwaltung. Schwerpunkt auf Linux und
                        Open-Source-Lösungen.
                    </p>

                    <div class="tech-list">
                        <span>OPNsense</span>
                        <span>Proxmox</span>
                        <span>Univention</span>
                        <span>WireGuard</span>
                        <span>Nginx</span>
                    </div>

                </div>

            </div>

            <!-- Managed Dienste -->
            <div class="col-12 col-md-6 mb-4">

                <div class="service-card h-100">

                    <div class="service-icon">
                        <i class="fa-solid fa-cloud"></i>
                    </div>

                    <h5>Managed Dienste</h5>

                    <p>
                        Gehostete Dienste auf eigener Infrastruktur. Kein Drittanbieter,
                        volle Datenkontrolle. Mailhosting, Cloud-Speicher, Ticketsystem,
                        Passwortmanager, Fernwartung und mehr aus einer Hand.
                    </p>

                    <div class="tech-list">
                        <span>Mailcow</span>
                        <span>Nextcloud</span>
                        <span>Zammad</span>
                        <span>Bitwarden</span>
                        <span>RustDesk</span>
                    </div>

                </div>

            </div>

            <!-- Webentwicklung -->
            <div class="col-12 col-md-6 mb-4">

                <div class="service-card h-100">

                    <div class="service-icon">
                        <i class="fa-solid fa-code"></i>
                    </div>

                    <h5>Webentwicklung</h5>

                    <p>
                        Komplexe Webanwendungen und Automatisierungslösungen. Entwicklung
                        nah an den realen Abläufen des Kunden. Das Ziel ist immer: mit
                        wenigen Klicks zum Ergebnis, Freude an der Arbeit.
                    </p>

                    <div class="tech-list">
                        <span>Vue.js</span>
                        <span>JavaScript</span>
                        <span>n8n</span>
                        <span>MariaDB</span>
                    </div>

                </div>

            </div>

            <!-- Automation -->
            <div class="col-12 col-md-6 mb-4">

                <div class="service-card h-100">

                    <div class="service-icon">
                        <i class="fa-solid fa-gears"></i>
                    </div>

                    <h5>Automation</h5>

                    <p>
                        Industriesteuerungen und Heimautomation. Von der
                        Schaltanlage bis zur vernetzten Gebäudesteuerung,
                        zuverlässige Lösungen für Gewerbe und Wohngebäude.
                    </p>

                    <div class="tech-list">
                        <span>Siemens</span>
                        <span>B&R</span>
                        <span>Loxone</span>
                        <span>openHAB</span>
                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'TheServiceComponent',

    }

</script>

<style scoped>

    .service-card {

        border: 1px solid #e8eef5;
        border-radius: 8px;
        padding: 1.75rem;
        transition: all 0.25s ease;
        background: #fff;

    }

    .service-card:hover {

        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(11, 95, 165, 0.1);
        border-color: rgba(0, 140, 255, 0.25);

    }

    .service-icon {

        font-size: 1.6rem;
        color: #0B5FA5;
        margin-bottom: 1rem;

    }

    .service-card h5 {

        font-weight: 600;
        margin-bottom: 0.75rem;
        color: #1a2a3a;

    }

    .service-card p {

        color: #5a6a7a;
        font-size: 0.92rem;
        line-height: 1.65;

    }

    .tech-list {

        display: flex;
        flex-wrap: wrap;
        gap: 0.4rem;
        margin-top: 1rem;

    }

    .tech-list span {

        background: rgba(11, 95, 165, 0.07);
        border: 1px solid rgba(11, 95, 165, 0.15);
        color: #0B5FA5;
        font-size: 0.75rem;
        padding: 0.2rem 0.6rem;
        border-radius: 3px;

    }

</style>
